<template>
    <fragment>
        <div id="wrap">
            <skp-gnb @router-reload="routerReload()"></skp-gnb>

            <!-- container -->
            <div id="container">
                <div class="container_wrap">
                    <!-- snb -->
                    <keep-alive>
                        <hhp-snb></hhp-snb>
                    </keep-alive>
                    <!-- //snb -->

                    <!-- contents -->
                    <!-- <a href="javascript:" @click="logout">logout</a> -->
                    <router-view :key="$route.fullPath"></router-view>
                    <!-- //contents -->
                </div>
            </div>
            <!-- //container -->

            <!-- FOOTER -->
            <keep-alive>
                <skp-footer />
                <!-- //FOOTER -->
            </keep-alive>
        </div>
        <div class="goto_top">
            <a href="javascript:" class="scroll_top_btn"><span class="sr_only">TOP</span></a>
        </div>
    </fragment>
</template>

<script>
import axios from 'axios';
import SDLUtil from '@/utils/SDLUtil';
import SKPSnb from '@/skpComponents/view/basis/main/SKPSnb';

import $ from 'jquery';
import SKPGnb from '~vb/main/SKPGnb';
import AdminSnb from '~va/main/AdminSnb';
import SKPFooter from '~vb/main/SKPFooter';

import HhpCerts from '@/skpComponents/common/HhpCerts';
import HHPSnb from '~vb/anysvcmobile/HHPSnb';

// import '/static/css/hhp_admin.css';

// import './fsw';

// axios.interceptors.response.use(
//     HhpCerts.handleHhpResponseInterceptor,
//     (error) => Promise.reject(error),
// );

export default {
    data() {
        return {
            accessAllowed: false,
            count: 1,
        };
    },
    components: {
        // 'admin-snb': AdminSnb,
        'skp-gnb': SKPGnb,
        // 'skp-snb': SKPSnb,
        'hhp-snb': HHPSnb,
        'skp-footer': SKPFooter,
    },
    methods: {

        logout() {
            return axios
                .get(`${SDLUtil.API_URL}/basis/certificate/CertLogout.skp`)
                .then(response => {
                    console.log("logout response", response.data);
                    this.$router.push({path: '/basis/certificate/CertLogin'});
                })
                .catch(err => {
                    console.log('err', err);
                });
            
        },

        btnGotoTop() {
            $(window).scroll(function() {
                if ($(this).scrollTop() > 200) {
                    $('.goto_top').fadeIn();
                } else {
                    $('.goto_top').fadeOut();
                }
            });

            $('.scroll_top_btn').click(function() {
                $('html, body').animate(
                    {
                        scrollTop: 0,
                    },
                    400,
                );
                return false;
            });
        },

        checkCert() {
            console.log('checkCert Started: ', this.$router.currentRoute);
            const path = this.$router.currentRoute.path;
            if (path.startsWith('/basis/certificate')) {
                this.accessAllowed = true;
                return;
            }
            if (path.endsWith('RequestCert') || path.endsWith('RequestIssue')) {
                this.accessAllowed = true;
                return;
            }
            
            if (this.count > 10) return;
            this.count += 1;
            return;
        },

        fasoo() {
            //URL Authentication code
            var arrSerial = Array("84F2DC9FD2E9F029F905E67E9D23E57D","7AEAE05012FF1C5CBE65D93720493D01","4E6AA9F00852D37DFF6E7CD237DF06D8","66153FBBD6F3698D75CEEF36A2E406F5");

            //Rights : "VIEWSOURCE","SAVEAS","PRINT","SECURE_PRINT","COPY","EMAILPAGE","SCREENCAPTURE", "SAVELINK", "DRAGDROP_NOCOPY"
            var arrRights = Array();

            //Exceptional IP Address
            var arrIPGroup = Array();

            //Error report & Installation
            var strErrUrl = "http://skp.samsungcsportal.com/basis/anysvcmobile/fasoo/FSWError.html";

            //Client Version
            var ClientSetupVersion = Array(2,6,4,1);

            function GoError(win, errNo)
            {
                win.location.href = strErrUrl+"?errNo="+errNo;
                return;
            }

            function FswExcept(bExcept)
            {
                document.getElementById("WebDM").nExceptCtrl = bExcept;
            }

            function ProtectSecurePage()
            {
                if ( navigator.appName != "Microsoft Internet Explorer" )
                {
                    if ( navigator.appName == "Opera" )
                    {
                        self.opener = self;
                        window.close();
                        return;
                    }

                    GoError(top, 2);
                    return;
                }
                
                if ( parseInt(navigator.userAgent.charAt(30)) < 6 )
                {
                    GoError(top, 2);
                    return;
                }

                try
                {
                    var iVersion;
                    var InstalledClientVer;
                    for ( iVersion=0 ; iVersion < ClientSetupVersion.length ; iVersion++ )
                    {
                        InstalledClientVer = document.getElementById("f_swv").GetClientVersion(iVersion);

                        if (InstalledClientVer < ClientSetupVersion[iVersion])
                        {
                            GoError(top, -2);
                            return;
                        }
                        else if (InstalledClientVer > ClientSetupVersion[iVersion])
                        {
                            break;
                        }
                    }

                    var nInitialize = 1;
                    var iSerial = 0;
                    document.getElementById("WebDM").SetLocationRef(document.location.href);

                    do
                    {
                        nInitialize = document.getElementById("WebDM").Initialize(arrSerial[iSerial++]);
                    } while ( nInitialize != 0 && iSerial < arrSerial.length );

                    if ( nInitialize != 0 )
                    {
                        GoError(top, nInitialize);
                        return;
                    }

                    nInitialize = document.getElementById("WebDM").ProtectWebPage(1);
                    
                    if ( nInitialize != 1 )
                    {
                        GoError(top, nInitialize);
                        return;
                    }
                }
                catch (e)
                {
                    GoError(top, -3);
                    return;
                }

                var iRights = 0;
                for ( iRights=0 ; iRights < arrRights.length ; iRights++ )
                {
                    try
                    {
                        document.getElementById("WebDM").Enable(arrRights[iRights]);
                    }
                    catch (e)
                    {
                        GoError(top, -3);
                        return;
                    }
                }
                
                var iIPGroup = 0;
                for ( iIPGroup=0 ; iIPGroup < arrIPGroup.length ; iIPGroup++ )
                {
                    var arrIPRange = arrIPGroup[iIPGroup];
                    var bRightsEnable = 1;
                    
                    for ( iRights=0 ; iRights < arrRights.length ; iRights++ )
                    {
                        if (arrIPRange[0] == arrRights[iRights])
                            bRightsEnable = 0;
                    }
                    
                    try
                    {			
                        document.getElementById("WebDM").ProtectWithIP(arrIPRange[0], arrIPRange[1], bRightsEnable);
                    }
                    catch (e)
                    {
                        GoError(top, -3);
                        return;
                    }
                }	
            }

            function ReleaseSecurePage()
            {
                try
                {
                    document.getElementById("WebDM").ProtectWebPage(0);
                }
                catch (e) { }
            }

            function Skip()
            {
                event.returnValue = false;
            }

            if ( parseInt(navigator.userAgent.charAt(30)) >= 5 )
            {
                document.onstop = Skip;
                document.onunload = ReleaseSecurePage;
                window.onunload = ReleaseSecurePage;
            }

            ProtectSecurePage();
            var Agent = navigator.userAgent;
            Agent = Agent.toLowerCase();
        
            if (Agent.indexOf("nt 6.") == -1) {
                //Non-Vista
                document.writeln("<object id= cmhver classid='clsid:43C01137-78B1-4C7D-8522-44B4D0A96E4B' style='display:none;' ");
                document.writeln("codebase='/basis/anysvcmobile/fasoo/client/fclient(v1.6.34.43)_20110321_blue3725.cab#version=1,6,34,43'></object>");
            } else {
                //Vista
                document.writeln("<object id= cmhver classid='clsid:43C01137-78B1-4C7D-8522-44B4D0A96E4B' style='display:none;' ");
                document.writeln("codebase='/basis/anysvcmobile/fasoo/client/fclient(v1.6.34.43)_20110321_blue3725_Win7.cab#version=1,6,34,43'></object>");
            }	

            goSetUser();
            
            
            function SetCustomUser (xid, uid){
                
                uid = uid.replace(/\n|\r\n/g, '\r');
                
                var nRet = f_sso.SetUserInfo(xid, uid, '', '', '', '', '', '', '', '');
                
                return nRet;
            }
            
            function goDRM(gubun){
                if(gubun == 'xp'){
                    location.href = "/basis/anysvcmobile/fasoo/cab/FSW(v2.6.4.1)_20110126_blue3725.exe";
                }else if(gubun == 'win7'){
                    location.href = "/basis/anysvcmobile/fasoo/cab/FSW(v2.6.4.1)_20110126_blue3725_Win7.exe";
                }
            }
            
            function goSetUser(){
                var uid = '';
                
                try{
                    uid = sUserID;
                    SetCustomUser('LOGIN', uid);
                }catch(e){
                    
                }		
            }

        }
    },

    created() {
        if ($('body').hasClass('admin_wrap') === false) $('body').addClass('admin_wrap');
        console.log('HHPMain.vue CREATED!');
        // this.checkCert();
    },

    mounted() {
        this.btnGotoTop();
        console.log('HHPMain.vue MOUNTED!');
        // this.fasoo();
    },

    destroyed() {
        console.log('HHPMain.vue DESTROYED!');
    },
};
</script>

<style scoped>
html /deep/ {
    @import url('/static/css/hhp_admin.css');
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/HHPMain.vue